import { Divider } from '@mui/material';
import { MessageBarContainer } from './MessageBarContainer';
import { MessageBarHeader } from './MessageBarHeader';
import {
  CareTeamTab,
  MessageBarTabView,
  MessageTab,
} from './MessageBarTabView';

type MessageBarEmbeddedProps = {
  infoIsOpen?: boolean;
  toggleInfo: () => void;
  onCollapse: () => void;
  standalone?: boolean;
  defaultTab: MessageTab;
  onChangeTab: (event: React.SyntheticEvent, newTab: MessageTab) => void;
  defaultPatientGuid?: string;
  onSelectChannel: (channelGuid: string) => void;
  onSelectPatient: (patientGuid: string) => void;
};

export const MessageBarEmbedded = (props: MessageBarEmbeddedProps) => {
  return (
    <MessageBarContainer width='350px' minWidth='350px'>
      <MessageBarHeader
        infoIsOpen={props.infoIsOpen}
        toggleInfo={props.toggleInfo}
        toggleMode={props.onCollapse}
        showInfoIcon={props.defaultTab === CareTeamTab}
      />
      <Divider sx={{ height: '10px', borderBottomWidth: 0 }} />
      <MessageBarTabView
        defaultTab={props.defaultTab}
        onChangeTab={props.onChangeTab}
        defaultPatientGuid={props.defaultPatientGuid}
        onSelectChannel={props.onSelectChannel}
        onSelectPatient={props.onSelectPatient}
      />
    </MessageBarContainer>
  );
};
